function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_26",
  "data-name": "Path 26",
  d: "M12,23A11,11,0,1,1,23,12,11,11,0,0,1,12,23Zm7.4-5.875a9,9,0,1,0-14.8,0C5.726,15.638,8.371,15,12,15S18.274,15.638,19.4,17.125ZM17.965,18.74C17.672,17.687,15.569,17,12,17s-5.672.687-5.965,1.74a9,9,0,0,0,11.929,0ZM12,15c-2.239,0-4-1.573-4-5a3.851,3.851,0,0,1,4-4,4,4,0,0,1,4,4.2C16,13.48,14.218,15,12,15Zm-2-5c0,2.269.818,3,2,3s2-.7,2-2.8A2.019,2.019,0,0,0,12,8,1.864,1.864,0,0,0,10,10Z",
  transform: "translate(-1 -1)",
  fillRule: "evenodd"
});

function SvgIconUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon_user.95d2f22a.svg";
export { ForwardRef as ReactComponent };